import Phaser from "phaser";
import {LevelManager} from "../game/LevelManager";
import GenericExplosionParticle from "../prefabs/particles/GenericExplosionParticle";
import FireworksExplosionParticle from "../prefabs/particles/FireworksExplosionParticle";
import {ParticleType, ParticleTypeValues} from "../prefabs/particles/ParticleFX";
import { Sounds } from '../sounds';

export const TileType = {
  Default: 'Default',
  Taz:'Taz',
  Critter:'Critter',
  Bumper:'Bumper',

} as const;
export type TileTypeKeys = keyof typeof TileType;
export type TileTypeValues = typeof TileType[TileTypeKeys];
export default class Tile extends Phaser.GameObjects.Sprite {

  public HitForce:number = 1;
  public Score:integer = 10;
  public Health:integer = 1;
  public LastCollisionTime:number = 0;
  public ExplosionRadius:number = 0;
  public Textures:string[] = [];
  private textureName:string;
  public levelManager!:LevelManager;
  private explosionType:ParticleTypeValues | undefined;
  private multiplier:number = 0;
  private multiplierDuration:number = 0;
  private sfx:string[] = [Sounds.Track.BoxHit1,Sounds.Track.BoxHit2,Sounds.Track.BoxHit3,Sounds.Track.BoxHit4,Sounds.Track.BoxHit5,Sounds.Track.BoxHit6,Sounds.Track.BoxHit7,Sounds.Track.BoxHit8,Sounds.Track.BoxHit9];

  constructor(scene: Phaser.Scene,levelManager : LevelManager, x: number, y: number, properties?:any[], texture?: string, frame?: number | string) {

    if(texture == undefined)
    {
      texture = "";
    }
    // let texFrame = frame;
    // if((typeof frame) == "number" && frame != undefined) {
    //   let index : number = Number(frame);
    //   texFrame = scene.textures.get(texture).getFrameNames()[index];

    //   if (texFrame == undefined) {
    //     texFrame = "";
    //   }
    // }


    super(scene, x,y, texture, frame);
    this.textureName = texture;
    this.levelManager = levelManager;

    this.setDepth(this.y);
  
    if(properties != undefined) {
      for (let i = 0; i < properties?.length; ++i) {
        switch (properties[i].name) {
          case "HealthFrames":
            for(let ii = 1; ii < this.Health; ++ii) {
              this.Textures.push(properties[i].value[ii]);
            }
            break;
          case "Health":
            this.Health = properties[i].value;
            break;
          case "Score":
            this.Score = properties[i].value;
            break;
          case "HitForce":
            this.HitForce = properties[i].value;
            break;
          case "ExplosionRadius":
            this.ExplosionRadius = properties[i].value;
            break;
          case "ExplosionType":
            this.explosionType = properties[i].value;
            break;
          case "ScoreMultiplier":
            this.multiplier = properties[i].value;
            break;
          case "ScoreMultiplierDuration":
            this.multiplierDuration = properties[i].value;
            break;
        }
      }
    }
  }

  public hitTile():boolean
  {
    if(this.LastCollisionTime > 0 || this.Health < 0)
    {
      return false;
    }

    this.Health --;

    if(this.Health > 0) {
      this.LastCollisionTime = 100;
      this.setTexture(this.textureName,this.Textures[this.Health-1]);
      return false;
    }
    else if(this.Health == 0) {

      let particles = undefined;
      switch (this.explosionType)
      {
        case ParticleType.Generic:
          particles = new GenericExplosionParticle(this.scene,this.x,this.y);
          this.scene.app.AudioHandler.playSound(this.scene, this.sfx[Phaser.Math.Between(0,this.sfx.length-1)], Sounds.Channel.SFX, { volume: 0.5 });
          break;
        case ParticleType.Fireworks:
          particles = new FireworksExplosionParticle(this.scene,this.x,this.y);
          this.scene.app.AudioHandler.playSound(this.scene, Sounds.Track.Fireworks, Sounds.Channel.SFX, { volume: 0.5 });
          break;
      }
      if(particles != undefined) {
        this.scene.add.existing(particles);
      }

      
      this.destroy(true);

      return true;
    }
    return false;
  }

  public canExplode():boolean
  {
    if(this.ExplosionRadius > 0)
    {
      return true;
    }
    return false;
  }

  public updateTile(time: number, delta: number)
  {
    this.LastCollisionTime -= delta;
    if(this.LastCollisionTime < 0)
    {
      this.LastCollisionTime = 0;
    }
  }

  public canMultiplyScore():boolean
  {
    return this.multiplierDuration > 0;
  }

  public get scoreMultiplier()
  {
    return this.multiplier;
  }

  public get scoreMultiplerDuration()
  {
    return this.multiplierDuration;
  }

}

